import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import apiClient from '@services/api';

interface TopicRow {
  id: string;
  title: string;
  reply_count: number;
}

const ForumHighlights: React.FC = () => {
  // Tri-state: undefined = loading, null = failed/empty
  const [topics, setTopics] = useState<TopicRow[] | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    apiClient.get<TopicRow[]>('/forum/topics/most_discussed/')
      .then((res) => {
        if (cancelled) return;
        const rows = Array.isArray(res.data) ? res.data.slice(0, 4) : [];
        setTopics(rows.length ? rows : null);
      })
      .catch(() => { if (!cancelled) setTopics(null); });
    return () => { cancelled = true; };
  }, []);

  if (topics === null) return null;

  return (
    <div className="card p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-400">Forumda Öne Çıkanlar</span>
        <Link to="/forum" className="text-[11px] text-accent-400 hover:text-accent-300">Tümü →</Link>
      </div>
      {topics === undefined ? (
        <div className="animate-pulse space-y-2 py-1">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-3.5 bg-white/[0.06] rounded w-5/6" />
          ))}
        </div>
      ) : (
        <div className="divide-y divide-white/[0.04]">
          {topics.map((t) => (
            <Link
              key={t.id}
              to={`/forum?topic=${t.id}`}
              className="flex items-center justify-between gap-3 py-2 hover:bg-white/[0.03] rounded px-1.5 -mx-1.5 transition-colors"
            >
              <span className="text-[13px] text-gray-300 truncate">{t.title}</span>
              <span className="flex items-center gap-1 text-[11px] text-gray-500 shrink-0">
                <MessageCircle size={11} /> {t.reply_count}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ForumHighlights;
